import type { ReactElement } from 'react';
import React, { useState } from 'react';
import { faPersonCircleCheck } from '@fortawesome/free-solid-svg-icons';
import TableActions from 'atom-components/table-actions-lite';
import type { ManageMarkingMark } from 'services/assist-api/entities/test-instance-response-mark/types';
import SetActiveReviewerModal from './set-active-reviewer-modal';

type Props = {
  mark: ManageMarkingMark;
};

export default function SetActiveReviewerButton({ mark }: Props): ReactElement {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <SetActiveReviewerModal
        mark={mark}
        isOpen={isModalOpen}
        onClose={(): void => setIsModalOpen(false)}
      />

      <TableActions.Button
        tooltip="Set Active Reviewer"
        onClick={(): void => setIsModalOpen(true)}
        icon={faPersonCircleCheck}
      />
    </>
  );
}
